import { useSelector } from "react-redux";
import styles from "./index.module.scss";
import Comment from "../../../product/bottom/comment";

export default function Reviews({ productId }) {
  const reviews = useSelector(
    (state) => state.reviewsAndQuestions.data[productId]?.REVIEWS || [],
  );

  return (
    <>
      {reviews &&
        Array.isArray(reviews) &&
        reviews.map((review) => (
          <div key={review.ID} className={styles.Item}>
            <div className={styles.Author}>
              <div className={styles.Ava}>{review.NAME?.[0] || "?"}</div>
              <div className={styles.Name}>{review.NAME}</div>
              <div className={styles.Date}>{review.DATE}</div>
              <div className={styles.Rating}></div>
            </div>
            <div className={styles.Block}>
              {review.POSITIVE && (
                <div className={styles.Text}>
                  <span>Достоинства</span>
                  {review.POSITIVE}
                </div>
              )}
              {review.NEGATIVE && (
                <div className={styles.Text}>
                  <span>Недостатки</span>
                  {review.NEGATIVE}
                </div>
              )}
              {review.COMMENT && (
                <div className={styles.Text}>
                  <span>Отзыв</span>
                  {review.COMMENT}
                </div>
              )}

              {review.ANSWER && (
                <div className={styles.Comments}>
                  <Comment comment={review.ANSWER} />
                </div>
              )}
            </div>
          </div>
        ))}
    </>
  );
}
